import 'css-chunksrc/client/pages/capacityPage/toolbar/yearNavigation/styles.scss';export default {
  "root": "_root_bkkjt_1",
  "yearNavigation": "_yearNavigation_bkkjt_5",
  "arrow": "_arrow_bkkjt_16",
  "leftArrow": "_leftArrow_bkkjt_23",
  "rightArrow": "_rightArrow_bkkjt_30",
  "year": "_year_bkkjt_5",
  "calendarButton": "_calendarButton_bkkjt_45",
  "opened": "_opened_bkkjt_54",
  "calendarIcon": "_calendarIcon_bkkjt_54",
  "listRoot": "_listRoot_bkkjt_64"
};